import React, { useState } from "react";
import { getAside2components } from "../../middleware/getVizDetails";
import DropZoneComp from "./components/Aside2Components/DropZoneComp";
import CustomizeComp from "./components/Aside2Components/CustomizeComp";
import { useSelector } from "react-redux";
import { getL1SheetProperty } from "./WorkbookSlice";

export default function Aside2({ currentSheet, dataSourceID }) {
  const { Sheetid } = currentSheet;
  console.log(currentSheet, Sheetid);
  const VizchartType = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "VizType")
  );

  const [tab, setTab] = useState("data");

  const aside2Components = getAside2components(VizchartType);
  const aside2DataComponents = aside2Components.DataArrayComponents;
  const aside2CustomizeComponents = aside2Components.CustomizeArrayComponents;
  console.log(aside2CustomizeComponents);

  return (
    <>
      <div className="flex justify-between w-full items-center h-[5%] border-b border-gray-300">
        <button
          className={`px-2 py-1 w-1/2 text-gray-600 h-full ${
            tab === "format" ? "border-r border-gray-300" : "lg:shadow-md"
          }`}
          onClick={() => setTab("data")}
        >
          Data
        </button>
        <button
          className={`px-2 py-1 w-1/2 text-gray-600 h-full ${
            tab === "data" ? "border-l border-gray-300" : "lg:shadow-md"
          } `}
          onClick={() => setTab("format")}
        >
          Format
        </button>
      </div>

      {tab === "data" ? (
        <main className="flex flex-col gap-2 overflow-hidden overflow-y-auto h-[95%] custom-scroll pt-1">
          {/* Render data based on the "add" tab */}
          {aside2DataComponents.map((controller, i) => (
            <DropZoneComp
              key={i}
              ControllerProps={controller}
              parentKey="query"
              currentSheet={currentSheet}
              VizchartType={VizchartType}
              dataSourceID={dataSourceID}
            />
          ))}
        </main>
      ) : (
        <main className="flex flex-col gap-2 overflow-hidden overflow-y-auto px-2 h-[95%] custom-scroll pt-1">
          {aside2CustomizeComponents.map((Controller, i) => (
            <CustomizeComp
              key={Sheetid + i}
              ControllerProps={Controller}
              parentKey="customization"
              currentSheet={currentSheet}
              VizchartType={VizchartType}
            />
          ))}
        </main>
      )}
    </>
  );
}
